import { CozyCardPreferences } from './CozyCardPreferences';
import { HR } from 'foundations-components/transitional/components/HR';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { getHasInactiveCards } from '../utils/getHasInactiveCards';
import { DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { NextLastActivityCardPreferences } from './NextLastActivityCardPreferences';
import { InactiveCardPreferences } from './InactiveCardPreferences';
import { useBoardPanelPresentationContext } from '../context/BoardPanelPresentationContext';
import { useHasCardsV2 } from '../hooks/useHasCardsV2';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CardsTab = () => {
  const hasCardsV2 = useHasCardsV2();
  const {
    objectTypeId
  } = useBoardPanelPresentationContext();
  const hasInactiveCards = getHasInactiveCards(objectTypeId);
  const isDealObjectType = objectTypeId === DEAL_TYPE_ID;
  const isTicketObjectType = objectTypeId === TICKET_TYPE_ID;
  const showNextLastActivityPreferences = isDealObjectType || isTicketObjectType;
  if (hasCardsV2) {
    return /*#__PURE__*/_jsx(PanelSection, {
      paddingInline: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.tabs.cardsv2"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PanelSection, {
      paddingInline: "0",
      children: /*#__PURE__*/_jsx(CozyCardPreferences, {})
    }), hasInactiveCards && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsxs(PanelSection, {
        paddingInline: "0",
        children: [showNextLastActivityPreferences && /*#__PURE__*/_jsx(View, {
          marginBlockEnd: "400",
          as: "div",
          children: /*#__PURE__*/_jsx(NextLastActivityCardPreferences, {
            isDealObjectType: isDealObjectType
          })
        }), /*#__PURE__*/_jsx(InactiveCardPreferences, {})]
      })]
    })]
  });
};
export default CardsTab;